import { session, appState, EP, THU_IMIE, API_BASE } from '../config.js';
import { fmt } from '../format.js';
import { ICONS, hydrateIcons, svg } from '../icons.js';
import { lineChart } from '../chart.js';
import { DEMO, demoDay } from '../demo.js';
import { apiGet, apiPost, apiPut, noData, imieFor } from '../api.js';
import { C, spinner, emptyRow, toast } from '../ui.js';
import { closeModal } from '../modal.js';
import { go } from '../router.js';
import { applyRole, canDelete } from '../auth.js';
import { renderOpsRows, toolBtns, hintLine } from './operations.common.js';

export async function viewAuto(){
  C().innerHTML=`<div class="panel"><div class="panel-head"><h2>Automatic Operations</h2><div class="btns">${toolBtns()}</div></div>
    <div class="panel-body" style="padding:0"><table><thead><tr><th>Date</th><th>Total Weight</th>${canDelete()?'<th>Actions</th>':''}</tr></thead>
    <tbody id="opsBody"><tr><td colspan="3">${spinner}</td></tr></tbody></table></div></div>${hintLine()}`;
  let rows=DEMO.auto;
  try{const r=await apiGet('GetApi.php',{ID:session.IMIE,TableName:EP.autoList});const d=await r.json();if(!noData(d))rows=d.map(x=>[x.Date,Number(x['SUM(Weight)']??x.Total??0)])}catch(e){appState.OFFLINE=true;applyRole()}
  renderOpsRows('auto','Automatic',session.IMIE,rows);
}
